export default __webpack_public_path__ + "static/media/coveredInsurance.6aed041f.png";